import * as React from 'react';
import { IconProps } from 'vet-bones/design-system/components';

export const LaptopChecked: React.VFC<IconProps> = ({ size }) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10469_507)">
        <path
          d="M19.5 18.0037H4.5C4.10232 18.0032 3.72105 17.845 3.43984 17.5638C3.15864 17.2826 3.00046 16.9013 3 16.5037V6.00366C3.0004 5.60596 3.15856 5.22466 3.43978 4.94344C3.721 4.66222 4.1023 4.50406 4.5 4.50366H19.5C19.8977 4.50412 20.2789 4.6623 20.5602 4.94351C20.8414 5.22471 20.9995 5.60598 21 6.00366V16.5037C20.9995 16.9013 20.8413 17.2825 20.5601 17.5637C20.2789 17.8449 19.8977 18.0031 19.5 18.0037ZM4.5 6.00366V16.5037H19.5V6.00366H4.5Z"
          fill="currentColor"
        />
        <path d="M22.5 19.5037H1.5V21.0037H22.5V19.5037Z" fill="currentColor" />
        <path
          d="M11 12.1925L9.0575 10.25L8 11.3075L11 14.3075L16.25 9.0575L15.1925 8L11 12.1925Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10469_507">
          <rect fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
};
